// extracted by mini-css-extract-plugin
export default {"modal":"header_modal__OxJw-","fadeInDown":"header_fadeInDown__wzhMS"};